var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.08579L1.70711 0.792893C1.31658 0.402369 0.683417 0.402369 0.292893 0.792893C-0.0976305 1.18342 -0.0976305 1.81658 0.292893 2.20711L5.29289 7.20711C5.68342 7.59763 6.31658 7.59763 6.70711 7.20711L11.7071 2.20711C12.0976 1.81658 12.0976 1.18342 11.7071 0.792893C11.3166 0.402369 10.6834 0.402369 10.2929 0.792893L6 5.08579Z",
    fill: "#3C7363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeExpand);
export default __webpack_public_path__ + "static/media/Shape_expand.3a47e1a815e3c671e288ddb72a57cb72.svg";
export { ForwardRef as ReactComponent };